<template>
  <div class="edit-nav-wrap" :class="{ 'is-bg': showBg }">
    <i v-if="showRemove" class="el-icon-remove cursor-pointer z-10 w-full text-right" @click="handleRemove" />
    <menu-item v-if="isSectionVisible('selectModule')" class="pt-0 mb-4" label="选择模块">
      <im-select v-model="target.models" class="w-full" :options="modelOptions" size="small" multiple clearable
        placeholder="模块" />
    </menu-item>
    <menu-item v-if="showName" class="pt-0" label="名称">
      <base-input v-model="target[nameKey]" :keys="keys" :model-key="targetKey" :target-index="targetIndex"
        target-key="label" size="small" />
    </menu-item>
    <menu-item v-if="target?.icon" class="pt-4" label="ICON">
      <menu-background-image :target="target.icon" image-size-key="" />
    </menu-item>
    <menu-item v-if="!hideFuns?.includes('jumpLink')" :label="label">
      <el-radio-group v-model="target.navType" class="mt-2">
        <el-radio class="w-full" label="1">
          <span class="nav-label text-white font-normal text-12">外部链接</span>
          <div v-if="target.navType === NavTypeEnum.URL" class="w-full mt-2">
            <base-input v-model="target.url" class="w-full" clearable size="small" placeholder="https://example.com" />
          </div>
        </el-radio>
        <el-radio class="mt-4 w-full" label="4">
          <span class="nav-label text-white text-12 font-normal">站内页面</span>
          <div v-if="target.navType === NavTypeEnum.PAGE_PATH" class="w-full mt-2">
            <im-cascader
              v-model="target.pagePath"
              :options="pageCascaderOptions"
              clearable
              placeholder="站内页面"
            />
          </div>
        </el-radio>
        <el-radio class="mt-4 w-full" label="3">
          <span class="nav-label text-white text-12 font-normal">模块</span>
          <div v-if="target.navType === NavTypeEnum.MODEL" class="w-full mt-2">
            <im-select v-model="target.model" class="w-full" :options="modelOptions" size="small" clearable
              placeholder="模块" />
          </div>
        </el-radio>
      </el-radio-group>
    </menu-item>
  </div>
</template>

<script>
import { RadioGroup, Radio } from 'element-ui'
import menuItem from "~/components/menu/menuItem";
import BaseInput from "~/components/base/baseInput"
import ImSelect from "~/components/common/ImSelect";
import ImCascader from "~/components/common/ImCascader";
import { ModuleNameEnum, NavTypeEnum, WidgetModelNames } from '~/enums/siteEnum'
import { FooterWidgetModel, HeaderWidgetModel } from "~/site/model";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";

export default {
  name: 'NavEdit',
  components: {
    MenuBackgroundImage,
    menuItem,
    BaseInput,
    ImSelect,
    ImCascader,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  props: {
    showBg: {
      type: Boolean,
      default: false
    },
    menuSections: {
      type: Object,
      default() {
        return {}
      }
    },
    filterModules: {
      type: Array,
      default() {
        return []
      }
    },
    hideFuns: Array,
    site: {
      type: Object,
      default() {
        return {}
      }
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    showRemove: {
      type: Boolean,
      default: false
    },
    showName: {
      type: Boolean,
      default: false
    },
    nameKey: {
      type: String,
      default: 'label'
    },
    label: {
      type: String,
      default: '跳转事件'
    },
    keys: {
      type: Array,
      default() {
        return []
      }
    },
    targetIndex: {
      type: [Number, String],
      default: ''
    },
    targetKey: {
      type: String,
      default: ''
    },
    target: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      NavTypeEnum,
      name: '',
      type: '1',
      url: ''
    }
  },
  computed: {
    pageCascaderOptions() {
      const pages = this.SitePage.list || []
      const currentPageLink = this.SitePage.current
      return pages
        .filter(page => page.id !== currentPageLink)
        .map(page => {
        const item = {
          value: page.link,
          label: page.name
        }
        // 主页也显示二级选项（模块）
        const widgetList = page?.conf?.web?.site?.widgetList || []
        const children = this.formatPageWidgets(widgetList, page)
        if (children.length > 0) {
          item.children = children
        }
        return item
      })
    },
    modelOptions() {
      const site = this.site
      const widgetList = site.widgetList || []
      const indexObj = {}
      const otherMenus = []
      const ignores = [HeaderWidgetModel.name, FooterWidgetModel.name, WidgetModelNames.MenuManageWidgetModel, ...this.filterModules]
      const widgets = widgetList.filter(item => !ignores.includes(item.name))
      const options = widgets.map(item => {
        const label = item.moduleName
        const isDialogCollection = label === ModuleNameEnum.DialogCollection
        if (indexObj[label]) indexObj[label] = indexObj[label] + 1
        else indexObj[label] = 1
        const isSame = widgets.filter(tag => tag.moduleName === item.moduleName).length > 1
        const menu = {
          label: isSame ? `${label}-${indexObj[label]}` : label,
          value: item.id
        }
        if (isDialogCollection) {
          item.children.forEach(child => {
            otherMenus.push({
              label: child.menuName,
              value: child.id
            })
          })
          return null
        } else {
          return menu
        }
      }).filter(item => item?.label)
      options.push(...otherMenus)
      const maybeAdd = [
        { ignore: WidgetModelNames.SupportSettingWidgetModel, data: site?.supportSetting },
        { ignore: WidgetModelNames.MissionCenterSettingModel, data: site?.missionCenterSetting },
        { ignore: WidgetModelNames.PwaSettingWidgetModel, data: site?.pwaSetting }
      ]
      maybeAdd.forEach(({ ignore, data }) => {
        if (ignores.includes(ignore)) return
        if (!data?.id) return
        options.push({
          label: data.moduleName,
          value: data.id
        })
      })
      return options
    }
  },
  methods: {
    formatPageWidgets(widgetList, page) {
      const ignores = [HeaderWidgetModel.name, FooterWidgetModel.name, WidgetModelNames.MenuManageWidgetModel, ...this.filterModules]
      const indexObj = {}
      const otherMenus = []
      const widgets = widgetList.filter(item => !ignores.includes(item.name))
      const options = widgets.map(item => {
        const label = item.moduleName
        const isDialogCollection = label === ModuleNameEnum.DialogCollection
        if (indexObj[label]) indexObj[label] = indexObj[label] + 1
        else indexObj[label] = 1
        const isSame = widgets.filter(tag => tag.moduleName === item.moduleName).length > 1
        const menu = {
          value: item.id,
          label: isSame ? `${label}-${indexObj[label]}` : label
        }
        if (isDialogCollection) {
          item.children && item.children.forEach(child => {
            otherMenus.push({
              value: child.id,
              label: child.menuName
            })
          })
          return null
        }
        return menu
      }).filter(item => item?.label)
      options.push(...otherMenus)
      return options
    },
    close() {
      this.SiteMenu.close('navediter')
    },
    isSectionVisible(key, defaultVisible = false) {
      const cfg = this.menuSections || {}
      const visible = cfg[key]
      if (visible === undefined) return defaultVisible
      return !!visible
    },
    handleRemove() {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="less">
.edit-nav-wrap {
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.is-bg {
    background-color: var(--bg-color-base);
    border: 1px solid var(--bg-color-hover);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;

    &:hover {
      background: var(--bg-color-hover);
      border-color: var(--text-color-alpha-3);
      box-shadow: var(--shadow-lg);
    }
  }

  .el-radio__input.is-checked .el-radio__inner {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }

  .el-radio__inner {
    background-color: transparent;
    border-color: var(--text-color-alpha-3);

    &:hover {
      border-color: var(--primary-color);
    }
  }

  .nav-label {
    color: var(--text-color-alpha-9);
    transition: color 0.2s;
  }

  .el-radio__input.is-checked+.el-radio__label .nav-label {
    color: var(--primary-color);
    font-weight: 500;
  }

  .delete-btn {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    color: var(--text-color-alpha-4);

    &:hover {
      background: var(--opacity-error-color);
      color: var(--danger-color);
    }

    i {
      font-size: 14px;
    }
  }
}
</style>
